import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { InputLikeText, InputLikeWrapper, SearchRow } from '@framework/ui';
import { Radio, Select, Space, Typography } from 'antd';
import { ExportFileField } from './ExportFileTypes';
import { useExportFileSemanticOrders } from './useExportFileSemanticOrders';

interface ExportFileSemanticOrderCascaderProps {
  fields: ExportFileField[] | null | undefined;
  selected?: string[];
  value?: string[];
  onChange: (value: string[]) => void;
  isLoading?: boolean;
}

const DIRECTIONS = [
  { value: 'asc', label: 'Crescente' },
  { value: 'desc', label: 'Decrescente' },
];

/**
 * Componente per la selezione degli ordinamenti sui campi semantici
 */
export function ExportFileSemanticOrderCascader(
  props: ExportFileSemanticOrderCascaderProps,
) {
  const { fields, selected, value, onChange, isLoading } = props;
  const { t } = useTranslation();

  const { orders, options, addOrder, removeOrder, setDirection } =
    useExportFileSemanticOrders({ fields, selected, value, onChange });

  return (
    <>
      <Typography.Paragraph>
        Imposta l'ordinamento per i campi selezionati
      </Typography.Paragraph>
      <Space direction="vertical" style={{ width: '100%' }} size={12}>
        {orders.map(order => {
          return (
            <SearchRow
              key={order.key}
              select={
                <InputLikeText
                  left
                  text={<Typography.Text strong>{order.label}</Typography.Text>}
                />
              }
              input={
                <InputLikeWrapper right>
                  <Radio.Group
                    value={order.direction}
                    onChange={e =>
                      setDirection(order.key, e.target.value as 'asc' | 'desc')
                    }
                  >
                    <Radio value="asc">{DIRECTIONS[0].label}</Radio>
                    <Radio value="desc">{DIRECTIONS[1].label}</Radio>
                  </Radio.Group>
                </InputLikeWrapper>
              }
              onRemove={() => removeOrder(order.key)}
            />
          );
        })}

        <Select
          style={{ width: '100%' }}
          loading={isLoading}
          options={options}
          placeholder={
            <Space>
              <PlusOutlined aria-hidden />
              {t('export-semantic-order.placeholder', 'Aggiungi ordinamento')}
            </Space>
          }
          value={undefined}
          onSelect={(fieldKey: string | undefined) => addOrder(fieldKey)}
          disabled={!options.length}
          showSearch
          optionFilterProp="label"
        />
      </Space>
    </>
  );
}
